import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class LandingPageComponent {


  @Input() firstBook: string;

  constructor(private router: Router) {
  }

  goReco(){
    this.router.navigate(['book/' + this.firstBook]);
  }

}
